import { render } from "./vendorCode1Nexus.vue?vue&type=template&id=ecea8238"
import script from "./vendorCode1Nexus.vue?vue&type=script&lang=js"
export * from "./vendorCode1Nexus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__